import React, { useEffect, useState } from 'react';
import { db } from '../../../utils/firebase'; // Adjust the path if needed
import { collection, query, where, orderBy, onSnapshot, limit } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const Pending_delivery = ({ onClose, delivery_agent }) => {

    const navigate = useNavigate()
    const [pendingDeliveries, setPendingDeliveries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lastDoc, setLastDoc] = useState(null);
    const [error, setError] = useState(null);
    const resultPerPage = 10; // You can change this as needed

    useEffect(() => {
        const fetchPendingDeliveries = () => {
            const deliveriesRef = collection(db, "delivery_requests");
            const q = query(deliveriesRef, orderBy("timestamp", "desc"), limit(resultPerPage));


            const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
                const list = [];
                QuerySnapshot.forEach((doc) => {
                    // Assuming these fields represent the status, you can adjust if necessary
                    if (
                        (doc?.data().search_timed_out === false || doc?.data().search_timed_out === null) &&
                        (doc?.data().pay_timed_out === false || doc?.data().pay_timed_out === null) &&
                        (doc?.data().all_time_out === false || doc?.data().all_time_out === null) &&
                        (doc?.data().user_payment_timed_out === false || doc?.data().user_payment_timed_out === null) &&
                        (doc?.data().timed_out === false || doc?.data().timed_out === null)
                    ) {
                        list.push(doc?.data());
                    }
                });

                // Set the last document for pagination (if needed)
                setLastDoc(QuerySnapshot.docs[QuerySnapshot.docs.length - 1]);
                setPendingDeliveries(list);
                setLoading(false);
            }, (err) => {
                setError(err.message);
                setLoading(false);
            });

            return unsubscribe;
        };

        fetchPendingDeliveries();

        return () => {
            setPendingDeliveries([]);
            setLoading(true);
            setError(null);
        };
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-lg">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-lg font-semibold text-green-600">Pending Deliveries</h2>
                <div className="flex justify-end mt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                    >
                        x
                    </button>
                </div>

                {/* Display the pending deliveries */}
                <div className="mt-4">
                    {pendingDeliveries.length > 0 ? (
                        <ul>
                            {pendingDeliveries.map((delivery, index) => (
                                <li key={index} className="mb-4">
                                    <div className="border-b pb-2">
                                        {/* <p><strong>Order ID:</strong> {delivery.id}</p> */}
                                        <p><strong>Customer:</strong> {delivery.sender_fullname}</p>
                                        <p><strong>Location:</strong> {delivery.pickup_address}</p>
                                        <p><strong>Status:</strong> {delivery.delivery_status_is_pending ? "Pending" : "Accepted"}</p>
                                    </div>
                                    <p
                                        onClick={() => {
                                            console.log(delivery, delivery_agent);
                                            
                                            navigate("/App/Assign_Agent", {
                                                state: { 
                                                    delivery_details: delivery ,
                                                    delivery_agent_details: delivery_agent
                                                 },
                                            });
                                        }}
                                    >Assign Delivery</p>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No pending deliveries.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Pending_delivery;
